import styled, { css } from 'styled-components';
import { themeGet } from '../theme/themeGet/get.js';
import { responsiveProperty } from '../../utils/responsiveProperty/responsiveProperty.js';
import { aiTextColor } from '../theme/utils.js';

var typographyBase = css(["font-family:", ";"], themeGet('fontFamily.default'));
var truncate = css(["white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"]);
var typographyDefaults = {
  $fontSize: 'medium',
  $fontWeight: 'regular',
  $fontStyle: 'normal',
  $lineHeight: 'default',
  $appearance: '200'
};
var Typography = styled.span.attrs(function (props) {
  return Object.assign(Object.assign({}, typographyDefaults), props);
}).withConfig({
  displayName: "Typography",
  componentId: "sc-8jd0kh-0"
})(["", ";", ";", ";", ";", ";", ";", ";"], typographyBase, function (_ref) {
  var $fontSize = _ref.$fontSize;
  return $fontSize && responsiveProperty('fontSize', $fontSize);
}, function (_ref2) {
  var $fontWeight = _ref2.$fontWeight;
  return $fontWeight && responsiveProperty('fontWeight', $fontWeight);
}, function (_ref3) {
  var $fontStyle = _ref3.$fontStyle;
  return $fontStyle && responsiveProperty('fontStyle', $fontStyle);
}, function (_ref4) {
  var $lineHeight = _ref4.$lineHeight;
  return $lineHeight && responsiveProperty('lineHeight', $lineHeight);
}, function (_ref5) {
  var $appearance = _ref5.$appearance;
  return $appearance === 'ai' ? aiTextColor('500') : $appearance && responsiveProperty('color', $appearance || '200');
}, function (props) {
  return props.$truncate && truncate;
});
var headingsBase = css(["", ";font-weight:400;margin:0;color:", ";"], typographyBase, themeGet('colors.text.300'));
var H1 = styled.h1.withConfig({
  displayName: "H1",
  componentId: "sc-8jd0kh-1"
})(["", ";", ";", ";", ";"], headingsBase, responsiveProperty('fontSize', {
  base: '1.75rem',
  sm: '2.25rem'
}), responsiveProperty('lineHeight', {
  base: '2.25rem',
  sm: '3rem'
}), function (props) {
  return props.$truncate && truncate;
});
var H2 = styled.h2.withConfig({
  displayName: "H2",
  componentId: "sc-8jd0kh-2"
})(["", ";", ";", ";", ";"], headingsBase, responsiveProperty('fontSize', {
  base: '1.625rem',
  sm: '2rem'
}), responsiveProperty('lineHeight', {
  base: '2.125rem',
  sm: '2.75rem'
}), function (props) {
  return props.$truncate && truncate;
});
var H3 = styled.h3.withConfig({
  displayName: "H3",
  componentId: "sc-8jd0kh-3"
})(["", ";", ";", ";", ";"], headingsBase, responsiveProperty('fontSize', {
  base: '1.5rem',
  sm: '1.75rem'
}), responsiveProperty('lineHeight', {
  base: '2rem',
  sm: '2.375rem'
}), function (props) {
  return props.$truncate && truncate;
});
var H4 = styled.h4.withConfig({
  displayName: "H4",
  componentId: "sc-8jd0kh-4"
})(["", ";", ";", ";", ";"], headingsBase, responsiveProperty('fontSize', {
  base: '1.375rem',
  sm: '1.5rem'
}), responsiveProperty('lineHeight', {
  base: '1.875rem',
  sm: '2rem'
}), function (props) {
  return props.$truncate && truncate;
});
var H5 = styled.h5.withConfig({
  displayName: "H5",
  componentId: "sc-8jd0kh-5"
})(["", ";font-size:1.25rem;line-height:1.75rem;", ";"], headingsBase, function (props) {
  return props.$truncate && truncate;
});
var H6 = styled.h6.withConfig({
  displayName: "H6",
  componentId: "sc-8jd0kh-6"
})(["", ";font-size:1rem;line-height:1.375rem;", ";"], headingsBase, function (props) {
  return props.$truncate && truncate;
});

export { H1, H2, H3, H4, H5, H6, Typography, truncate, typographyBase };
